import React, {useContext} from 'react';
import {ConfigProvider} from 'antd';
import {observer} from "mobx-react-lite";
import {RouterProvider, createBrowserRouter} from "react-router-dom";
import {AuthContext} from "./provider/authentication/keycloak.authentication.provider";
import {StoreContext} from "./store.context";
import {RoleRouter} from "./route/role.route";
import Authenticating from "./components/page/authenticationg.page";
import LockScreen from "./components/page/lockScreen.page";
import {TranslationRouter} from "./route/translation.route";
import TranslateModal from "./components/modal/form/translate.modal";
import {UserRouter} from "./route/user.route";
import {ServicerRouter} from "./route/servicer.route";
import {AgencyRouter} from "./route/agency.route";
import {HomeRouter} from "./route/home.route";
import {BankRouter} from "./route/bank.route";
import {OtherCompanyRouter} from "./route/otherCompany.route";
import {FallBackRouter} from "./route/fallback.route";

/**
 * Authorization check would be easier, right now waiting for this feature
 * https://github.com/remix-run/react-router/discussions/9564
 */
const App: React.FC = observer(() => {

    const {
        appStore: {
            moduleStore: {
                roleStore,
                userStore,
                servicerStore,
                agencyStore,
                bankStore,
                otherCompanyStore,
            },
            authStore: {token},
            inactive,
        },
    } = useContext(StoreContext);

    const authContext = useContext(AuthContext);

    const isAuthenticated = (): boolean => {
        return typeof token !== "undefined"
    }

    const router = createBrowserRouter([
        HomeRouter(),
        RoleRouter({isAuthenticated, roleStore}),
        UserRouter({isAuthenticated, userStore}),
        ServicerRouter({isAuthenticated, servicerStore}),
        AgencyRouter({isAuthenticated, agencyStore}),
        BankRouter({isAuthenticated, bankStore}),
        OtherCompanyRouter({isAuthenticated, otherCompanyStore}),
        TranslationRouter({isAuthenticated}),
        FallBackRouter()
    ]);

    return (
            <ConfigProvider theme={{token: {colorPrimary: "#bad60a"}}}>
                {inactive && <LockScreen/>}
                {!authContext.isAuthenticated && <Authenticating/>}
                {(!inactive && authContext.isAuthenticated) && <RouterProvider router={router}/>}

                <TranslateModal/>
            </ConfigProvider>
    );
});

export default App;